

// Default colors
export const clrDefaultMarkFill = '#B6B7B8'
export const clrDefaultMarkStroke = '#B6B7B8'

export const clrDefaultHoverFill = '#7AD0DD'
export const clrDefaultHoverStroke = '#7AD0DD'
